import axios from 'axios';
// axios.defaults.withCredentials = true;
export default axios.create({
  // baseURL: 'https://api.coronacheck.net/physician/',

  // baseURL: 'https://api.docl.org/physician/',
  baseURL:'https://qr.brainpill.io/api/gov/',
  withCredentials:true,

});